var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rating/Star Fill",
    d: "M7.53834 2.00376C7.70914 1.59312 8.29086 1.59312 8.46166 2.00376L9.99874 5.69936C10.0707 5.87247 10.2336 5.99076 10.4204 6.00574L14.4102 6.3256C14.8535 6.36114 15.0332 6.91439 14.6955 7.20373L11.6557 9.80758C11.5133 9.92956 11.4512 10.1209 11.4947 10.3033L12.4234 14.1966C12.5265 14.6292 12.0559 14.9711 11.6764 14.7393L8.26063 12.653C8.10062 12.5553 7.89938 12.5553 7.73937 12.653L4.32363 14.7393C3.94408 14.9711 3.47345 14.6292 3.57665 14.1966L4.50534 10.3033C4.54884 10.1209 4.48665 9.92956 4.34426 9.80758L1.30453 7.20373C0.966758 6.91439 1.14652 6.36114 1.58985 6.3256L5.57955 6.00574C5.76645 5.99076 5.92925 5.87247 6.00126 5.69936L7.53834 2.00376Z",
    fill: "#343839"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9dd89aa7fedfc0fcf47e019dc0e52026.svg";
export { ForwardRef as ReactComponent };